import Auth from '../auth/Auth';
import BidPackInfo from '../models/BidPackInfo';
import { WebClient } from './WebClient'

class ApiBidPack extends WebClient {
     async getGetBidPackInfo(): Promise<BidPackInfo | undefined> {
            const url = "/document/bidpack";
    
            return this.get(url, Auth.getAuthToken()).then(res => {
                if (res.status === 200) {
                    return res.data || undefined;
                }
                return undefined;
            }).catch(() => { return undefined; });
        }
}

export default new ApiBidPack();
